export const validationRules = (field, t) => {
  switch (field) {
    case 'firstName':
      return {
        name: 'firstName',
        validation: (val) => val.length,
        validationMessage: t('Register.FirstNameValidation'),
      };
    case 'lastName':
      return {
        name: 'lastName',
        validation: (val) => val.length,
        validationMessage: t('Register.LastNameValidation'),
      };
    case 'phoneOrEmail':
      return {
        name: 'phoneOrEmail',
        validation: (val) => {
          const mailFormat = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          return val.match(mailFormat);
        },
        validationMessage: t('Register.EmailValidation'),
      };
    case 'password':
      return {
        name: 'password',
        validation: (val) => {
          const passwordFormat = /^(?=.*[A-Z])(?=.*\d)[A-Za-z\d!@#$%^&*?_~]{8,}$/;
          return val.match(passwordFormat);
        },
        validationMessage: t('Register.PasswordValidation'),
      };
    case 'confirmPassword':
      return {
        name: 'confirmPassword',
        validation: (val, passVal?) => val === passVal,
        validationMessage: t('Register.PasswordMatchValidation'),
      };
    case 'brandName':
      return {
        name: 'brandName',
        validation: (val) => val.length,
        validationMessage: t('Register.BrandNameValidation'),
      };
    case 'language':
      return {
        name: 'language',
        validation: (val) => val.length,
        validationMessage: t('Register.LanguageValidation'),
      };
    case 'currency':
      return {
        name: 'currency',
        validation: (val) => val.length,
        validationMessage: t('Register.CurrencyValidation'),
      };
    default:
      return {
        name: '',
        validation: () => void 0,
        validationMessage: '',
      };
  }
};

export const validateFormData = (formData, t) => {
  const errors: any = [];
  Object.keys(formData).map((fieldKey, index) => {
    const fieldVal = formData[fieldKey];
    let isValid = false;
    if (validationRules(fieldKey, t)) {
      if (fieldKey === 'confirmPassword' && formData.password) {
        isValid = validationRules(fieldKey, t).validation(fieldVal, formData.password);
      } else {
        isValid = validationRules(fieldKey, t).validation(fieldVal);
      }
      if (!isValid) {
        errors[fieldKey] =
          validationRules(fieldKey, t).validationMessage ?? t('General.SomethingIsWrong');
      }
    }
  });

  return errors;
};
